export default __webpack_public_path__ + "media/images/features/ana/title_right-18a32fc9780b237cd0d706fd0caa61a6.png";